import type { FaireProductEntity } from "../../entity_types/product";

export const p_dfbdcrzs34: FaireProductEntity = {
  token: "p_dfbdcrzs34",
  type: "product",
  name: "Forest Green Ribbed Knotted Newborn Baby Gown Sleepwear",
  brandToken: "b_3pci2bfmjr",
  brandName: "Three Little Tots",
  imageUrl:
    "https://cdn.faire.com/fastly/35a0c86f74e4cc40266a634ffc02605f6a0849caa1461e5024a62a29abeb0f80.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/166704d9f886eed28bcf6812604353c96844b9b0aeb1f874a4a5c0473db54b82.jpeg",
    "https://cdn.faire.com/fastly/3943e23a5927cea252c6b5e1c1735e591dd705cf872575b5299dab80af38eca9.jpeg",
    "https://cdn.faire.com/fastly/d9cce98a6d1531a984812acba21d627ca8ddc4005e6f3ec269cfc07651fa0042.jpeg",
    "https://cdn.faire.com/fastly/1c81a3efd7086877d9dadca87075f663199ef5076a08ab5aab09b4aed7e5470a.jpeg",
    "https://cdn.faire.com/fastly/14134a8c361eca7b0b45e5f0a81e5dfa97e8fcc35a42363c7404c8f715d8033d.jpeg",
    "https://cdn.faire.com/fastly/6e3cb27f89a90f16de385ae7d89d30271f8fef94e43a7dc11c408167faa53b2f.jpeg",
    "https://cdn.faire.com/fastly/182aa0c401ea1f14dbd8062f597eff3fe1ca8842377e41ee03e0cea9dac8b518.jpeg",
    "https://cdn.faire.com/fastly/721a66de1d5e60631633c33f09653849933de01a99e47905b3b577263ab79a8c.jpeg",
    "https://cdn.faire.com/fastly/5cb7700ad2eeadedc7ed41635ad95ddda3e26d95a967ed324b7808778eed3ce0.jpeg",
    "https://cdn.faire.com/fastly/232e8999b5581e5d95886dca9f407e032181f7cfce6660980a8e0564c07f2e70.jpeg",
    "https://cdn.faire.com/fastly/05a0f36af8fed1c9f546c787ea881ea0c61b794485decb2ba5802f2a18dc9eb1.jpeg",
    "https://cdn.faire.com/fastly/8a79abdc1c2672b888b82e083480313edaebcce10a216e6cf13d84749dab7e18.jpeg",
    "https://cdn.faire.com/fastly/e7dda6cf86cd76e60e635cc3a4d5342133e51ac6b8af43379d453c34c727635b.jpeg",
    "https://cdn.faire.com/fastly/e3f00807c9fc366a1b1e7084c41292a9151d1946284c36853b69b34fe290daa5.jpeg",
    "https://cdn.faire.com/fastly/6e741a48c0853ba2b1352d86d6ca51f851f401aa96d2d83a033ec95b9ffcc7ed.jpeg",
    "https://cdn.faire.com/fastly/56ea405f25f2fd7061fd270bf616eff812b9a830a23e64078b8b5b6b23c13e96.jpeg",
    "https://cdn.faire.com/fastly/414773c5e1d0152dea7be18e5803f334abcda239557d178ac08aecaf4274cc3e.jpeg",
    "https://cdn.faire.com/fastly/5da27d52b1937c4bc75a2972b7d653a1cdcda65fd70933c5bc75168c14f92243.jpeg",
    "https://cdn.faire.com/fastly/455be2dd46cefbcdc68e8eeb02b83c7806616a6620072230e88e9ce0cae045f5.jpeg",
    "https://cdn.faire.com/fastly/15502bbf5d0cce54f778c6a4370b6189d2b4866bbd19be89e8ca84e3ed768783.jpeg",
    "https://cdn.faire.com/fastly/ff0d1810ec6115276de8b164fd7b3e7f4a3ca37d040f26d4199fc4a166e2869c.jpeg",
    "https://cdn.faire.com/fastly/ea11c08392101787569280a35d30fe35fe19a1d6b03333361d03e12dbe404a96.jpeg",
    "https://cdn.faire.com/fastly/ea8c2ebb9173dbcac7eeeda592d0f283fbdfce4877ab3780d821243125c95463.jpeg",
    "https://cdn.faire.com/fastly/265e422698d8808187cfca4766edff343e1bbcd3d63ddda1bde6314b76641f19.jpeg",
    "https://cdn.faire.com/fastly/ec69eac3f448226b1e44ee2450e6119a208c526b358c117a78fe6b43c292664d.jpeg",
    "https://cdn.faire.com/fastly/199ba6d6bbb5cfa6bf39bc8ef3acb0341280e776f674ba148da2888a4e38ce5c.jpeg",
    "https://cdn.faire.com/fastly/4feaab48ade5d20699e5876b995ee2915a2c386da0bc822ff5cec55dd712a64e.jpeg",
    "https://cdn.faire.com/fastly/3c7e38172fa8d1f3d25d329fefbf4f8aef52f2a134ad78a4f0ece563a42054b1.jpeg",
    "https://cdn.faire.com/fastly/df83b28c2857568ad97f5f13dad5bd4ca54a1a3f33fe734e03222d00abee1646.jpeg",
    "https://cdn.faire.com/fastly/bcb7cef3161b83be050aab0b614c7a11b84515896f6ee172569d68fa34fb9a29.jpeg",
    "https://cdn.faire.com/fastly/d3fca81702848e9416af5e4072534a51cb24ef513c5d9263039580a20fb1cb8a.jpeg",
    "https://cdn.faire.com/fastly/20107c1a32a4e6b4b7b216eeec25268ce6a0aaa500bef1c3ca48888ae6a44bb4.jpeg",
    "https://cdn.faire.com/fastly/8f2f58ffa2bffade1ab385ccf2b3f6da491160d9cadd315d91c25df072dafb1c.jpeg",
    "https://cdn.faire.com/fastly/89683e5e94dc863c9f3e891695e5923c3b88b084f99424aa65038d4200784279.jpeg",
  ],
  priceDollars: 10.3,
  description:
    "These baby gowns are so soft you will never want your baby in anything else. Fabric is designed to be soft, comfortable, and stretchy. The tie bottom allows for an easy night-time diaper change. The pull-down tabs on the shoulder make it easy to dress and change. Newborn-3 month fits approx 5lbs-15lbs.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:37.204Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
